<!-- 
  back button remove
  show video preview
  loader for button (loading store)
  on save navigate back
  check favicon 404s
  searchable series
 -->
<script context="module" lang="ts">
  type FileEventTarget = EventTarget & { files: FileList };
  type FormEvent = Event & {
    detail: {
      data: any;
      valid: boolean;
    };
  };
</script>

<script lang="ts">
  import { onMount, tick } from "svelte";
  import { headerDisplayStore, loadingStore } from "../stores/General";
  import Form from "../components/form/Form.svelte";
  import TextArea from "../components/form/TextArea.svelte";
  import Validators from "../utils/validators";
  import AutoCompleteCombo from "../components/form/AutoCompleteCombo.svelte";
  import FormButtons from "../components/form/FormButtons.svelte";
  import { languages } from "../assets/GeoData";
  import { useNavigate } from "svelte-navigator";
  import { getById, getList, update } from "../api";
  import { sendFileFormDataRequest } from "../api/crud";

  import InputWrapper from "../components/form/InputWrapper.svelte";
  import BooleanDropDown from "../components/form/BooleanDropDown.svelte";

  import PlainInput from "../components/form/PlainInput.svelte";
  import FileInput from "../components/form/FileInput.svelte";
  import DatePicker from "../components/form/DatePicker.svelte";
  import { parseDate } from "../utils/conv";
  import moment from "moment";
  import SelectInput from "../components/form/SelectInput.svelte";

  export let id;
  const navigate = useNavigate();

  // main form
  let form;
  /**
   * file form
   * TODO: file doesn't work with Form atm;
   * */
  // file form's data
  let fd: FormData;
  // unused, store fd's file
  // fd's file's name
  // let filename = "";

  // form fields
  let asset_type;
  let product_category;
  let description;
  let title;
  let creator;
  let duration;
  let language: any = "en";
  let start_date = new Date();
  let end_date = "";
  let keywords = [];
  let categories = [];
  let series;
  let topper;
  let iab_top_tier = null;
  let iab_tier = null;
  let iab_top_tier_use = null;

  // form state
  let isUpdate = !!id;
  let loading = false;
  /** @deprecated until checkHash returns */
  let hashExist = false;
  let module_name = "topper";

  // needs to be moved to wrapper component
  function parseCategories(values) {
    return values.map((val) => {
      return {
        value: val.iab_category_id,
        label: `${val.iab_category_id} | ${
          val.top_tier ? val.top_tier + " | " : ""
        }${val.name}`,
        name: val.name,
        top_tier: val.top_tier,
      };
    });
  }
  function calculateTiers(e) {
    categories = e.detail || [];
    const topTier = [];
    const tier = [];
    categories.forEach((c) => {
      // is top_tier
      if (!c.top_tier) {
        topTier.push(c.name);
      } else {
        tier.push(c.name);
        topTier.push(c.top_tier);
      }
    });

    // set teh valued of tier to new set
    iab_top_tier = topTier?.length ? [...new Set(topTier)].join(", ") : null;
    iab_tier = tier?.length ? [...new Set(tier)].join(", ") : null;
  }
  // video playback
  let source = "";
  let poster = "";
  // validation
  let rules = {
    title: {
      validators: [
        Validators.required("Asset Name is required"),
        Validators.minLength(2),
        // Validators.isLowerCase(),
        Validators.exists(validateTextField, "Asset Name already exists"),
      ],
    },
    product_category: {
      validators: [Validators.required("Product Category is required")],
    },
    type: {
      validators: [Validators.required("Asset Type is required")],
    },
    // files: {
    //   validators: id ?? [Validators.fileRequired("Video File is required")],
    // },
    // creator: { validators: [Validators.required("Creator is required")] },
    // categories: { validators: [Validators.required("Categories is required")] },
  };
  if (!id)
    rules["files"] = {
      validators: [Validators.fileRequired("Video File is required")],
    };
  /**
   * chechHash Checks topper hash and returns ok or not
   *
   * See caller for details
   * @param {{values: string}} data post body
   * @returns Promise<{status: boolean}>
   */
  // async function checkVideoHash(ev) {
  // NOTE: save file from OnFileInput and use it here
  // let hash = await FileMD5(file);
  // sendPostRequest('/topper/check', { values: hash })
  //   .then((response) => {
  //     if (response?.status == true) {
  //       hashExist = true;
  //     } else {
  //       hashExist = false;
  //       videoID = hash;
  //     }
  //   })
  //   .catch((error) => {
  //     hashExist = false;
  //   });
  // }

  // function checkVideoTitle(event) {
  //   title = event.detail.target.value;
  //   let pageSize = 1;
  //   let page = 1;
  //   let sortBy = 'title';
  //   let sortOrder = 'ASC';
  //   let filter = { title };

  //   if (title) {
  //     getList('topper', pageSize, page, sortBy, sortOrder, filter)
  //       .then((response) => {
  //         if (response?.count > 0) {
  //           isExist = response.data.some((el) => el.title === title);
  //         } else {
  //           isExist = false;
  //         }
  //       })
  //       .catch((error) => {
  //         isExist = false;
  //       });
  //   }
  // }

  // function onSearchIabCategories(event) {
  //   if (event.detail) {
  //     loadIabCategories(event.detail);
  //   }
  // }

  // textareas don't save to the form context currently
  function onVideoDescriptionChange(event) {
    const desc = event.detail.target.value;
    description = desc;
  }

  /**
   * get the fd and attach data to it for submission
   * @param e FormEvent
   */
  async function onSubmit(e: FormEvent) {
    const data = e.detail.data;
    const file = fd && (fd.get("files") as File);
    const d: any = {
      asset_type: data.type.value,
      duration: parseFloat(data.duration) ?? 0,
      product_category: data?.product_category.value,
      title: data.title,
      description: description,
      language: data.language.value,
      start_date: data.start_date
        ? parseDate(moment(data.start_date).format("M/DD/YYYY"))
        : parseDate(moment().format("M/DD/YYYY")),
      end_date: data.end_date
        ? parseDate(moment(data.end_date).format("M/DD/YYYY"))
        : null,
      creator: data.creator.value,
      keywords: data.keywords?.map((k) => k.label || k),
      // categories: data.categories?.map(({ label }) => label),
      iab_categories: data.categories?.map(({ value }) => value),
      iab_top_tier,
      iab_tier,
      iab_top_tier_use,
      series: Array.isArray(data.series)
        ? data.series?.map(({ label }) => label)
        : data.series
        ? [data.series.label]
        : [],
      // add lastModified date
      update_at: file
        ? parseDate(moment(file.lastModified).format("M/DD/YYYY"))
        : topper?.update_at,
      original_filename: file?.name || null,
    };

    if (isUpdate) {
      d.topper_id = id;
      delete d.original_filename;
    }

    try {
      loadingStore.on(module_name, { disableGlobalIndicator: true });
      if (isUpdate) {
        await update(module_name, d);
        headerDisplayStore.ShowNotification({
          title: "Data saved successfully",
          subtitle: "",
        });
      } else if (!!fd && e.detail.valid) {
        fd.append("data", JSON.stringify(d));
        await sendFileFormDataRequest("/topper/upload/single", fd, "formData");
        headerDisplayStore.ShowNotification({
          title: "Data saved successfully",
          subtitle: "",
        });
      } else {
        return headerDisplayStore.ShowError({
          title: "Studio Asset File",
          subtitle: "Asset File is missing",
        });
        // throw new Error(
        //   JSON.stringify({
        //     message: {
        //       status: "Studio Asset File",
        //       errors: "Asset File is missing",
        //     },
        //   })
        // );
      }
      navigate("/studio");
    } catch (error) {
      const e = JSON.parse(error.message);
      headerDisplayStore.ShowError({
        title: e.status || "Studio Server Error",
        subtitle: e.errors,
      });
    } finally {
      loadingStore.off(module_name);
    }
  }
  function onFileInput(e: any) {
    const { form } = e.target;
    const formData = new FormData(form);
    const files = formData.get("files");
    fd = new FormData();
    fd.append("files", files);
  }
  async function getVideo() {
    if (id) {
      try {
        loadingStore.on(module_name);
        const res = await getById(module_name, id);
        topper = res.topper;
        asset_type = topper?.asset_type ?? "";
        description = topper?.description ?? "";
        duration = topper?.duration ?? "";
        language = topper?.language ?? "en";
        product_category = topper?.product_category ?? "";
        title = topper?.title ?? "";
        source = topper?.asset_url ?? "";
        poster = topper?.thumbnail_url ?? "";
        start_date = topper?.start_date ?? "";
        end_date = topper?.end_date ?? "";
        creator = topper?.creator ?? "FG";
        keywords = topper.keywords.map((k) => k.keyword_id);
        categories = parseCategories(topper.iab_categories);
        calculateTiers({ detail: categories });
        series =
          Array.isArray(topper.series) && topper.series.length
            ? topper.series[0].series_id
            : topper.series?.series_id || null;
        topper = topper;
      } catch (error) {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      } finally {
        loadingStore.off(module_name);
      }
    }
  }

  onMount(() => {
    void getVideo();
    headerDisplayStore.SetTitle(isUpdate ? "Edit Studio" : "New Studio");
  });

  function onCancel() {
    navigate("/studio");
  }
  async function validateTextField(title) {
    // title = e.detail.target.value;
    let page = 1;
    let sortBy = "title";
    let sortOrder = "ASC";
    let filter = { title_match: title };

    const { data } = await getList(
      module_name + "/exists",
      10,
      page,
      sortBy,
      sortOrder,
      filter
    ).catch((error) => {
      headerDisplayStore.ShowError({
        title: "Server error",
      });
    });
    // console.log(data, id);
    const count = data?.length || 0;
    if (count && data[0]?.topper_id == id) {
      return [];
    }

    return data;
  }
</script>

{#if (isUpdate && topper) || !isUpdate}
  <div class="max-w-full mx-auto py-6 px-4 mb-10">
    <Form {rules} on:submit={onSubmit} bind:this={form}>
      <div class="w-full">
        <div class="flex flex-row gap-2">
          <div class="bg-white p-4 rounded-md w-3/5 flex flex-col gap-2">
            <div class="flex flex-row gap-2">
              <InputWrapper label="Asset Name" required name="title">
                <PlainInput name="title" value={title} />
              </InputWrapper>
              <InputWrapper
                label="Product Category"
                required
                name="product_category"
              >
                <SelectInput
                  bind:value={product_category}
                  items={[
                    "Ad Studio",
                    "Open",
                    "Instant",
                    "Instant+",
                    "Prime",
                    "Slate",
                  ]}
                  isSearchable={false}
                  isClearable={false}
                  placeholder="Product Category"
                  name="product_category"
                  on:select={(event) => {}}
                />
              </InputWrapper>
            </div>
            <div class="flex flex-row gap-2">
              <InputWrapper label="Asset type" required name="type">
                <SelectInput
                  bind:value={asset_type}
                  items={[
                    "Brand Ad",
                    "Stitched Ad",
                    "Topper",
                    "Chaser",
                    "BookendOpen",
                    "BookendClose",
                  ]}
                  isSearchable={false}
                  isClearable={false}
                  placeholder="Asset type"
                  name="type"
                />
              </InputWrapper>
              <InputWrapper label="Creator" name="creator">
                <SelectInput
                  bind:value={creator}
                  items={["FG", "SL"]}
                  isSearchable={false}
                  isClearable={false}
                  placeholder="Creator"
                  name="creator"
                />
              </InputWrapper>
            </div>
            <div class="flex flex-row gap-2">
              <InputWrapper label="Language">
                <AutoCompleteCombo
                  bind:value={language}
                  items={languages}
                  isSearchable
                  isClearable={false}
                  placeholder="Language"
                  name="language"
                />
              </InputWrapper>
              <InputWrapper label="Asset series">
                <AutoCompleteCombo
                  bind:value={series}
                  isClearable={true}
                  placeholder="Asset series"
                  name="series"
                  entity="series"
                  isMulti={false}
                  allowNewItem={true}
                />
              </InputWrapper>

              <!-- <InputWrapper label="Duration" name="duration" required>
                <AutoCompleteCombo
                  bind:value={creator}
                  loadOptions={fetchSeries}
                  items={seriesList}
                  items={['FG', 'SL']}
                  isSearchable={false}
                  isClearable={false}
                  placeholder="Creator"
                  name="creator"
                />
              </InputWrapper> -->
            </div>
            <div class="flex flex-row gap-2">
              <div class="w-full">
                <DatePicker
                  label="Start Date"
                  name="start_date"
                  reset={false}
                  initialValue={start_date}
                />
              </div>
              <div class="w-full">
                <DatePicker
                  label="End Date"
                  name="end_date"
                  reset={true}
                  initialValue={end_date}
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4 w-2/5">
            {#if duration > 0}
              <div class="bg-white py-4 px-6 rounded-md w-full">
                <InputWrapper label="Duration" name="duration">
                  <PlainInput
                    bind:value={duration}
                    name="duration"
                    placeholder="Duration Missing"
                    type="text"
                    readonly
                  />
                </InputWrapper>
              </div>
            {/if}
            <div class="bg-white py-4 px-6 rounded-md w-full">
              <InputWrapper label="Video Description" name="description">
                <TextArea
                  bind:value={description}
                  name="description"
                  placeholder="Add description"
                  on:change={onVideoDescriptionChange}
                  type="textarea"
                />
              </InputWrapper>
            </div>
            <div class="bg-white py-4 px-6 rounded-md w-full flex gap-2">
              <InputWrapper label="IAB Value" name="categories">
                <AutoCompleteCombo
                  placeholder="Search categories"
                  name="categories"
                  isClearable
                  isMulti
                  on:change={calculateTiers}
                  isSelectAll={false}
                  isUnknown={false}
                  value={categories}
                  entity="iab_categories"
                  itemParsingMethod={parseCategories}
                />
              </InputWrapper>
            </div>
            <div class="bg-white py-4 px-6 rounded-md w-full">
              <InputWrapper label="Tags" name="keywords">
                <AutoCompleteCombo
                  placeholder="Search tag"
                  name="keywords"
                  isClearable
                  isMulti
                  isSelectAll={false}
                  isUnknown={false}
                  bind:value={keywords}
                  entity="keywords"
                  allowNewItem
                />
              </InputWrapper>
            </div>
          </div>
        </div>
      </div>
      <FormButtons {isUpdate} on:cancel={onCancel} />
      <div class="w-3/5 mt-4 bg-white p-4 rounded-md z-20">
        <FileInput
          title="Upload media or drag and drop"
          name="files"
          onInput={onFileInput}
          multiple={false}
          previewFile={true}
          readonly={isUpdate}
          {poster}
          {source}
        />
      </div>
    </Form>
  </div>
{/if}
